import { FcGeneratorOptions, FcSvg } from '@dtx-company/flowcode-generator-types/src'
import { logger } from '@dtx-company/logger'
import PromiseWorker from 'promise-worker'
import type { GeneratorWorkerInput, GeneratorWorkerOutput } from './workers/generator.worker'

let promiseWorker: PromiseWorker | undefined

export async function fcGenerateFlowcode(options: FcGeneratorOptions): Promise<FcSvg> {
  // detect if Web workers are available
  if (self.Worker) {
    if (!promiseWorker) {
      const worker = new Worker(new URL('./workers/generator.worker', import.meta.url))
      promiseWorker = new PromiseWorker(worker)
    }
    const result = await promiseWorker.postMessage<GeneratorWorkerOutput, GeneratorWorkerInput>({
      options
    })
    if (result.ok) {
      return FcSvg.fromJson(result.svg)
    } else {
      logger.logError(result.error, {
        team: 'templates',
        name: 'Worker could not generate flowcode.'
      })
      throw new Error('Worker could not generate flowcode.')
    }
  } else {
    // fallback
    const module = await import('@dtx-company/flowcode-generator-v2/src')
    return module.fcGenerateFlowcode(options)
  }
}
